import { useCallback } from 'react';
import isNil from 'lodash/isNil';
import { useFlagService } from '@atlassian/jira-flags';
import { CLIENT_ERROR_403, CLIENT_ERROR_404 } from '../../common/errors-constants.tsx';
import type { ErrorMessages, ExtractedResponse } from '../use-connected-projects/types.tsx';
import { useGenericFlag } from '../use-generic-flag/index.tsx';

export const useHandleError = () => {
	const { showFlag } = useFlagService();
	const showGenericFlag = useGenericFlag();

	return useCallback(
		(extractedResponse: ExtractedResponse, errorMessages: ErrorMessages) => {
			// in case of a timeout it will be null
			if (isNil(extractedResponse)) {
				showGenericFlag();
				throw new Error('No response available from BE');
			}

			if (!extractedResponse?.success) {
				const code = extractedResponse?.errors?.[0]?.extensions?.statusCode;

				if (code === 404) {
					showFlag({
						type: 'error',
						title: errorMessages['404'].title,
						description: errorMessages['404'].description,
					});
					throw new Error(CLIENT_ERROR_404);
				}

				if (code === 403) {
					showFlag({
						type: 'error',
						title: errorMessages['403'].title,
						description: errorMessages['403'].description,
					});
					throw new Error(CLIENT_ERROR_403);
				}

				showGenericFlag();
				throw new Error('Unknown BE error');
			}
		},
		[showFlag, showGenericFlag],
	);
};
